import { memo, useEffect, useState } from "react";
import CancelButton from "../../../framework/forms/helpercomponents/buttons/CancelButton";
import SaveButton from "../../../framework/forms/helpercomponents/buttons/SaveButton";
import * as API from '../../../framework/API/api'
import { ENTITYNAME, PLATFORMTYPE, TOAST_TYPES } from "../../../framework/constant/constant";
import { Checkbox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import AddRoundButton from "../../../framework/forms/helpercomponents/buttons/AddRoundButton";
import AudioTrack from "../AudioTrack";
import MediaDealRightEditForm from "./component/mediaDealRightEditForm";
import moment from "moment";
import { utility } from "../../../framework/utility/utilityProvider";
import { ConfirmDeleteAlert } from "../../../ConfirmAlert";
import DeleteRoundButton from "../../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import { useTranslation } from "../../../locale/useTranslation";
import MyMultiSelect from "../../../components/MyMultiSelect";
import CreateTransmissionForm from "../../../framework/OTT/CreateTransmissionForm";
import BossDialog from "../../../components/BossDialog";
import MediaExtensionEditForm from "../MediaExtensionEditForm";
import { EditPageHeader } from "../../../components/EditPageHeader";
import ToastNotification from "../../../components/ToastNotification";

const MultipleContentEditPanel = (props) => {

    const { selectedItems = [], setSelectedItems, entityName, mediaCategory = {}, gridData = [], setGridData, mainStyle = {}, onClose, contentCategory = {}, refresh } = props;

    const lang = useTranslation();
    const subHeadingStyle = { fontFamily: "Roboto", fontSize: "13px", fontWeight: "500", letterSpacing: "0.2px", lineHeight: "18px", color: "#191825", margin: "7px 10px", padding: 0 }
    const style = { display: "grid", gridTemplateColumns: "0.9fr 1.1fr", alignItems: "start", padding: "10px 0" }
    const width = "235px";
    const tableDataStyle = { fontFamily: "Roboto", fontSize: "13px", fontWeight: "400", letterSpacing: "0.2px", lineHeight: "18px", color: "#3C4048", padding: "10px" };
    const isHideMetaDataFields = entityName == ENTITYNAME.Series || entityName == ENTITYNAME.Season;

    const [pgRatings, setPGRatings] = useState([]);
    const [showMediadealrights, setShowMediadealrights] = useState({ show: false, isLinear: false });
    const [censorRatings, setCensorRatings] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [categories, setCategories] = useState([]);
    const [genres, setGenres] = useState([]);
    const [selectedFields, setSelectedFields] = useState({
        PGRating: { isSelected: false, value: null },
        CensorRating: { isSelected: false, value: null },
        Languages: { isSelected: false, value: null },
        ProductionYear: { isSelected: false, value: null },
        Categories: { isSelected: false, value: null },
        Genres: { isSelected: false, value: null },
        SubGenres: { isSelected: false, value: null },
        AudioTrack: { isSelected: false, value: null },
        linearRights: { isSelected: false, value: [] },
        nonLinearRights: { isSelected: false, value: [] },
        Keywords: { isSelected: false, value: null },
        transmissions: { isSelected: false, value: {} },
        extension: { isSelected: false, value: {} },
        // OttAsset: { isSelected: false, value: [] }
    });
    const [showTransmissionForm, setShowTransmissionForm] = useState(false);
    const [showExtensionForm, setShowExtensionForm] = useState(false);
    const [onSaveMultiExtensionData, setOnSaveMultiExtensionData] = useState(null);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        let pgRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
        if (pgRes.success) setPGRatings(pgRes.data);
        let crRes = await API.getDataLookup(ENTITYNAME.CensorRating, { sort: { Description: 1 } });
        if (crRes.success) setCensorRatings(crRes.data);
        let languages = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
        if (languages.success) setLanguages(languages.data);
        let categories = await API.getDataLookup(ENTITYNAME.ContentCategory, { sort: { Name: 1 } });
        if (categories.success) setCategories(categories.data);
        let genreRes = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
        if (genreRes.success) setGenres(genreRes.data);
    }

    const onCheckBoxSelection = (e) => {
        let key = e.target.name;
        setSelectedFields((old) => ({ ...old, [key]: { ...old[key], isSelected: e.target.value } }));
    }

    const onFieldValueChange = (e) => {
        let key = e.target.name;
        setSelectedFields((old) => ({ ...old, [key]: { ...old[key], value: e.target.value } }));
    }

    const setAudioTrackData = (data) => {
        setSelectedFields((old) => ({ ...old, AudioTrack: { ...old.AudioTrack, value: data } }));
    }

    const onMediadealrightsSave = (data) => {
        console.log(data);
        if (data.PlatformType.SID == PLATFORMTYPE[0].SID) {
            setSelectedFields((old) => ({ ...old, linearRights: { ...old.linearRights, value: [...old.linearRights.value, data] } }));
        }
        else {
            setSelectedFields((old) => ({ ...old, nonLinearRights: { ...old.nonLinearRights, value: [...old.nonLinearRights.value, data] } }));
        }
    }

    const onMediadealrightsClose = (isLinear) => {
        setShowMediadealrights({ show: !showMediadealrights.show, isLinear: isLinear });
    }

    const onMediadealrightsDelete = async (data) => {
        if (data.PlatformType.SID == PLATFORMTYPE[0].SID) {
            setSelectedFields((old) => ({ ...old, linearRights: { ...old.linearRights, value: old.linearRights.value.filter((item) => item._id !== data._id) } }));
        }
        else {
            setSelectedFields((old) => ({ ...old, nonLinearRights: { ...old.nonLinearRights, value: old.nonLinearRights.value.filter((item) => item._id !== data._id) } }));
        }
    }

    const defaultStyle = {
        position: "absolute",
        top: "91px",
        right: selectedItems.length > 0 ? 0 : "-500px",
        width: "500px",
        height: "76%",
        backgroundColor: "white",
        transition: 'all 0.3s linear',
        overflow: 'auto'
    }

    const handleSubmit = async () => {

        console.log("here");

        let saveData = {};
        let updatedValues = {
            media: {},
            dealRights: [],
            metaData: {},
            transmissions: null,
            Extension: {}
        };

        // ---------- Prepare saveData ----------
        Object.keys(selectedFields).forEach((key) => {
            if (selectedFields[key].isSelected && !['Genres', 'SubGenres', 'linearRights', 'nonLinearRights'].includes(key)) {
                saveData[key] = selectedFields[key].value;
            }
        });

        // ---------- GENRES ----------
        if (selectedFields.Genres.isSelected) {
            const Genres = selectedFields.Genres.value?.map((x) => ({
                _id: x._id,
                Description: x.Description
            })) || [];

            updatedValues.media.Genres = Genres;
        }

        // ---------- SUB GENRES ----------
        if (selectedFields.SubGenres.isSelected) {
            const SubGenres = selectedFields.SubGenres.value?.map((x) => ({
                _id: x._id,
                Description: x.Description
            })) || [];

            updatedValues.media.SubGenres = SubGenres;
        }

        // ---------- METADATA (LAST UPDATE ONLY) ----------
        if (Object.keys(saveData).length > 0) {

            if (selectedFields.PGRating.isSelected) {
                updatedValues.metaData.PGRating = (saveData?.PGRating && Object.keys(saveData.PGRating).length > 0) ? { _id: saveData.PGRating._id, Description: saveData.PGRating.Description } : {}
            }

            if (selectedFields.Languages.isSelected) {
                updatedValues.metaData.Languages = saveData?.Languages?.length > 0 ? saveData.Languages?.map(x => { return { _id: x._id, Description: x.Description } }) : [];
            }

            if (selectedFields.ProductionYear.isSelected) {
                updatedValues.metaData.ProductionYear = saveData?.ProductionYear;
            }

            if (selectedFields.Keywords.isSelected) {
                updatedValues.metaData.Keywords = saveData?.Keywords;
            }

            if (selectedFields.Categories.isSelected) {
                updatedValues.metaData.Categories = saveData?.Categories?.length > 0 ? saveData?.Categories?.map(x => { return { _id: x._id, Name: x.Name, parent: x.parent } }) : [];
            }

            if (selectedFields.CensorRating.isSelected) {
                updatedValues.metaData.CensorRating = (saveData?.CensorRating && Object.keys(saveData.CensorRating).length > 0) ? { _id: saveData.CensorRating._id, Description: saveData.CensorRating.Description } : {}
            }

            if (selectedFields.AudioTrack.isSelected) {
                updatedValues.metaData.AudioTrack = (saveData?.AudioTrack?.length > 0) ? saveData.AudioTrack.map(x => {
                    return {
                        Language: {
                            "_id": x.Language?._id,
                            "Description": x.Language?.Description,
                        },
                        TrackNumber: x?.TrackNumber
                    }
                }) : [];
            }
        }

        // ---------- LINEAR RIGHTS ----------
        if (selectedFields.linearRights?.isSelected) {
            updatedValues.dealRights.push(
                ...(Array.isArray(selectedFields.linearRights.value)
                    ? selectedFields.linearRights.value
                    : [selectedFields.linearRights.value])
            );
        }
        // ---------- NON LINEAR RIGHTS ----------
        if (selectedFields.nonLinearRights?.isSelected) {
            updatedValues.dealRights.push(
                ...(Array.isArray(selectedFields.nonLinearRights.value)
                    ? selectedFields.nonLinearRights.value
                    : [selectedFields.nonLinearRights.value])
            );
        }

        if (selectedFields.transmissions?.isSelected && Object.keys(selectedFields.transmissions.value).length > 0) {
            updatedValues.transmissions = selectedFields.transmissions.value;
        }

        // ---------- EXTENSION ----------
        if (selectedFields.extension?.isSelected) {
            updatedValues.metaData.Extension = selectedFields?.extension?.value;
        }

        const payload = {
            mediaCategory: mediaCategory && Object.keys(mediaCategory)?.length > 0 ? { _id: mediaCategory._id, SID: mediaCategory.SID, Description: mediaCategory.Description } : {},
            contentCategory: contentCategory && Object.keys(contentCategory)?.length > 0 ? { _id: contentCategory._id, SID: contentCategory.SID, Name: contentCategory.Name, parent: contentCategory.parent } : {},
            selectedMedia: selectedItems?.length > 0 ? selectedItems.map(x => { return { _id: x._id, SID: x.SID, Title: x.Title, AssetId: x.AssetId, MediaCategory: x.MediaCategory } }) : [],
            updatedValues
        }

        await API.bulkUpdateMediaByContentCategory(payload);

        if (selectedItems.length > 0) {
            let updatedItems = selectedItems.map((item) => {
                const { metaData, dealRights, ...updatedValues } = payload.updatedValues;
                return {
                    ...item,
                    ...updatedValues,
                    MetaData: metaData,
                    Publishings: dealRights,
                };
            });
            setSelectedItems(updatedItems);
            refresh && refresh();
            onClose && onClose(false);
        } else {
            setSelectedItems([]);
            onClose && onClose(true);
        }
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Saved Successfully' });
    };

    const handleTransmissionSelection = (transmissionData) => {
        let paylaod = {
            mediaEpisodes: selectedItems.map((x) => { return { _id: x._id.toString(), MediaCategory: x.MediaCategory } }),
            catalogue: {
                Catalogue: { _id: transmissionData.Catalogue._id, Description: transmissionData.Catalogue?.Description },
                ParentNodes: transmissionData.ParentNodes,
                Nodes: transmissionData.Nodes,
                Ott_Platforms: transmissionData.Ott_Platforms,
                TransmissionType: transmissionData.TransmissionType
            },
            entityName: entityName,
        }
        console.log({
            transmissions: {
                isSelected: true,
                value: paylaod,
            },
        });

        setSelectedFields((old) => ({
            ...old,
            transmissions: {
                isSelected: true,
                value: paylaod,
            },
        }));

        ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: "Transmission Added Successfully" });

        setShowTransmissionForm(false);
    }

    const onSaveExtension = (data) => {
        setOnSaveMultiExtensionData(data);
    };

    const onSaveExtensionData = () => {
        if (onSaveMultiExtensionData) {
            setSelectedFields((old) => ({
                ...old,
                extension: {
                    ...old.extension,
                    value: onSaveMultiExtensionData
                }
            }));
        }
        setShowExtensionForm(false);
    }

    return (
        <div>
            <div style={{ ...defaultStyle, ...mainStyle, display: "flex", flexDirection: "column", maxheight: "800vh", overflow: "hidden" }}>
                <div style={{ padding: "10px", position: "sticky", top: 0, zIndex: 10, background: "#fff", borderBottom: "1px solid #ddd" }}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h1 style={{ fontFamily: "Roboto", fontSize: "24px", margin: 0 }}>
                            Edit Multiple Assets ({selectedItems.length})
                        </h1>
                        <div className="d-flex gap-2">
                            <CancelButton onClick={() => { setSelectedItems([]); onClose && onClose(); }} />
                            <SaveButton onClick={handleSubmit} />
                        </div>
                    </div>
                </div>
                {/* 🔹 SCROLLABLE CONTENT (FIXED HEIGHT AREA) */}
                <div style={{ flex: 1, overflowY: "auto", padding: "15px" }}>
                    {/* PGRating */}
                    {mediaCategory.isLong && <div style={style}>
                        <div>
                            <Checkbox style={{ borderColor: "black" }} name="PGRating" value={selectedFields.PGRating.isSelected} onChange={onCheckBoxSelection} />
                            <span style={subHeadingStyle}>Pg Rating</span>
                        </div>
                        <DropDownList
                            disabled={!selectedFields.PGRating.isSelected}
                            style={{ width: width }}
                            data={pgRatings}
                            name="PGRating"
                            textField="Description"
                            dataItemKey="_id"
                            onChange={onFieldValueChange}
                        />
                    </div>}
                    {/* Censor Rating */}
                    {!isHideMetaDataFields && mediaCategory.isLong && <div style={style}>
                        <div>
                            <Checkbox style={{ borderColor: "black" }} name="CensorRating" value={selectedFields.CensorRating.isSelected} onChange={onCheckBoxSelection} />
                            <span style={subHeadingStyle}>Censor Rating</span>
                        </div>
                        <DropDownList
                            disabled={!selectedFields.CensorRating.isSelected}
                            style={{ width: width }}
                            data={censorRatings}
                            name="CensorRating"
                            textField="Description"
                            dataItemKey="_id"
                            onChange={onFieldValueChange}
                        />
                    </div>}
                    {/* Languages */}
                    {mediaCategory.isLong && <div style={style}>
                        <div>
                            <Checkbox style={{ borderColor: "black" }} name="Languages" value={selectedFields.Languages.isSelected} onChange={onCheckBoxSelection} />
                            <span style={subHeadingStyle}>Languages</span>
                        </div>
                        <MyMultiSelect
                            disabled={!selectedFields.Languages.isSelected}
                            style={{ width: width, maxHeight: "60px", overflow: "auto", border: "1px solid #E0E0E0", borderRadius: "4px", padding: "0 10px" }}
                            data={languages}
                            name="Languages"
                            textField="Description"
                            dataItemKey="_id"
                            onChange={onFieldValueChange}
                        />
                    </div>}
                    {/* Production Year */}
                    {mediaCategory.isLong && <div style={style}>
                        <div>
                            <Checkbox style={{ borderColor: "black" }} name="ProductionYear" value={selectedFields.ProductionYear.isSelected} onChange={onCheckBoxSelection} />
                            <span style={subHeadingStyle}>Production Year</span>
                        </div>
                        <input
                            disabled={!selectedFields.ProductionYear.isSelected}
                            name='ProductionYear'
                            onChange={onFieldValueChange}
                            type="number"
                            style={{ width: width, height: "30px", border: "1px solid #E0E0E0", borderRadius: "4px", padding: "0 10px" }}
                        />
                    </div>}
                    {/* Keywords */}
                    {mediaCategory.isLong && <div style={style}>
                        <div>
                            <Checkbox style={{ borderColor: "black" }} name="Keywords" value={selectedFields.Keywords.isSelected} onChange={onCheckBoxSelection} />
                            <span style={subHeadingStyle}>Keywords</span>
                        </div>
                        <input
                            disabled={!selectedFields.Keywords.isSelected}
                            name='Keywords'
                            onChange={onFieldValueChange}
                            type="text"
                            style={{ width: width, height: "30px", border: "1px solid #E0E0E0", borderRadius: "4px", padding: "0 10px" }}
                        />
                    </div>}
                    {/* Categories */}
                    {mediaCategory.isLong && <div style={style}>
                        <div>
                            <Checkbox style={{ borderColor: "black" }} name="Categories" value={selectedFields.Categories.isSelected} onChange={onCheckBoxSelection} />
                            <span style={subHeadingStyle}>Categories</span>
                        </div>
                        <MyMultiSelect
                            disabled={!selectedFields.Categories.isSelected}
                            style={{ width: width, maxHeight: "60px", overflow: "auto", border: "1px solid #E0E0E0", borderRadius: "4px", padding: "0 10px" }}
                            data={categories}
                            dataItemKey="_id"
                            textField="Name"
                            onChange={onFieldValueChange}
                            name={"Categories"}
                        />
                    </div>}
                    {/* Genres */}
                    {mediaCategory.isLong && <div style={style}>
                        <div>
                            <Checkbox style={{ borderColor: "black" }} name="Genres" value={selectedFields.Genres.isSelected} onChange={onCheckBoxSelection} />
                            <span style={subHeadingStyle}>{lang.genres_label}</span>
                        </div>
                        <MyMultiSelect
                            disabled={!selectedFields.Genres.isSelected}
                            style={{ width: width, maxHeight: "60px", overflow: "auto", border: "1px solid #E0E0E0", borderRadius: "4px", padding: "0 10px" }}
                            data={genres}
                            dataItemKey="_id"
                            textField="Description"
                            onChange={onFieldValueChange}
                            name={"Genres"}
                        />
                    </div>}
                    {/* Sub Genres */}
                    {mediaCategory.isLong && <div style={style}>
                        <div>
                            <Checkbox style={{ borderColor: "black" }} name="SubGenres" value={selectedFields.SubGenres.isSelected} onChange={onCheckBoxSelection} />
                            <span style={subHeadingStyle}>{lang.sub_genres_label}</span>
                        </div>
                        <MyMultiSelect
                            disabled={!selectedFields.SubGenres.isSelected}
                            style={{ width: width, maxHeight: "60px", overflow: "auto", border: "1px solid #E0E0E0", borderRadius: "4px", padding: "0 10px" }}
                            data={genres}
                            dataItemKey="_id"
                            textField="Description"
                            onChange={onFieldValueChange}
                            name={"SubGenres"}
                        />
                    </div>}
                    {/* Audio Track */}
                    {!isHideMetaDataFields && mediaCategory.isLong && <div style={style}>
                        <div>
                            <Checkbox style={{ borderColor: "black" }} name="AudioTrack" value={selectedFields.AudioTrack.isSelected} onChange={onCheckBoxSelection} />
                            <span style={subHeadingStyle}>Audio Track</span>
                        </div>
                        <div style={{ width: width, borderRadius: "4px" }}>
                            <AudioTrack disabled={!selectedFields.AudioTrack.isSelected} dataItem={{ AudioTrack: [] }} setAudioTrackData={setAudioTrackData} />
                        </div>
                    </div>}
                    {/* linear */}
                    <div style={style}>
                        <div>
                            <Checkbox style={{ borderColor: "black" }} name="linearRights" value={selectedFields.linearRights.isSelected} onChange={onCheckBoxSelection} />
                            <span style={subHeadingStyle}>Linear Rights</span>
                        </div>
                        <div style={{ width: width, borderRadius: "4px" }}>
                            <AddRoundButton disabled={!selectedFields.linearRights.isSelected} onClick={() => onMediadealrightsClose(true)} />
                            <div style={{ overflow: "auto", marginTop: "10px", scrollbarWidth: "none" }}>
                                <table className="table">
                                    <thead>
                                        <tr className="text-nowrap">
                                            <th scope="col"></th>
                                            <th scope="col">Channel</th>
                                            <th className="text-nowrap" scope="col">Start Date</th>
                                            <th className="text-nowrap" scope="col">End Date</th>
                                            <th className="text-nowrap" scope="col">Is Unlimited</th>
                                            <th scope="col">Exhibition</th>
                                            <th className="text-nowrap" scope="col">Repeat</th>
                                            <th className="text-nowrap" scope="col">Play Time Number</th>
                                            <th className="text-nowrap" scope="col">Play Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedFields.linearRights.value?.map((publishingData, index) => {
                                            return (
                                                <tr className="text-nowrap" key={index}>
                                                    <td><DeleteRoundButton disabled={!selectedFields.linearRights.isSelected} onClick={() => ConfirmDeleteAlert(() => onMediadealrightsDelete(publishingData), () => { })} /></td>
                                                    <td className="text-nowrap" style={tableDataStyle}>
                                                        {utility.displayArrayInPipe(publishingData?.Channel, 'FullChannelName')}
                                                    </td>
                                                    <td className="text-nowrap" style={tableDataStyle}>
                                                        {moment(publishingData?.PublishStartDate).utc().format('DD-MM-YYYY')}
                                                    </td>
                                                    <td className="text-nowrap" style={tableDataStyle}>
                                                        {moment(publishingData?.PublishEndDate).utc().format('DD-MM-YYYY')}
                                                    </td>
                                                    <td style={tableDataStyle}>
                                                        <Checkbox style={{ borderColor: "black" }} disabled={true} value={publishingData?.IsUnlimited} />
                                                    </td>
                                                    <td style={tableDataStyle}>
                                                        {publishingData?.Exhibitions}
                                                    </td>
                                                    <td style={tableDataStyle}>
                                                        {publishingData?.Repeats}
                                                    </td>
                                                    <td style={tableDataStyle}>
                                                        {publishingData?.PlayTimeNumber}
                                                    </td>
                                                    <td style={tableDataStyle}>
                                                        {publishingData?.PlayTime?.Description}
                                                    </td>
                                                </tr>
                                            )
                                        })}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {/* non-linear */}
                    <div style={style}>
                        <div>
                            <Checkbox style={{ borderColor: "black" }} name="nonLinearRights" value={selectedFields.nonLinearRights.isSelected} onChange={onCheckBoxSelection} />
                            <span style={subHeadingStyle}>Non-Linear Rights</span>
                        </div>
                        <div style={{ width: width, borderRadius: "4px" }}>
                            <AddRoundButton disabled={!selectedFields.nonLinearRights.isSelected} onClick={() => onMediadealrightsClose(false)} />
                            <div style={{ overflow: "auto", marginTop: "10px", scrollbarWidth: "none" }}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col"></th>
                                            <th scope="col">Platform</th>
                                            <th className="text-nowrap" scope="col">Start Date</th>
                                            <th className="text-nowrap" scope="col">End Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedFields.nonLinearRights.value?.map((publishingData, index) => {
                                            return (
                                                <tr className="text-nowrap" key={index}>
                                                    <td><DeleteRoundButton disabled={!selectedFields.nonLinearRights.isSelected} onClick={() => ConfirmDeleteAlert(() => onMediadealrightsDelete(publishingData), () => { })} /></td>
                                                    <td className="text-nowrap" style={tableDataStyle}>
                                                        {utility.displayArrayInPipe(publishingData?.Platform, 'Description')}
                                                    </td>
                                                    <td className="text-nowrap" style={tableDataStyle}>
                                                        {moment(publishingData?.PublishStartDate).utc().format('DD-MM-YYYY')}
                                                    </td>
                                                    <td className="text-nowrap" style={tableDataStyle}>
                                                        {moment(publishingData?.PublishEndDate).utc().format('DD-MM-YYYY')}
                                                    </td>
                                                </tr>
                                            )
                                        })}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {/* Transmission */}
                    <div style={style}>
                        <div>
                            <Checkbox style={{ borderColor: "black" }} name="transmissions" value={selectedFields.transmissions.isSelected} onChange={onCheckBoxSelection} />
                            <span style={subHeadingStyle}>Transmissions</span>
                        </div>
                        <div style={{ width: width, borderRadius: "4px" }}>
                            <AddRoundButton disabled={!selectedFields.transmissions.isSelected} onClick={() => setShowTransmissionForm(true)} />
                            <div style={{ overflow: "auto", marginTop: "10px", scrollbarWidth: "none" }}>
                                <table className="table">
                                    <thead>
                                        <tr className="text-nowrap">
                                            <th>Catalogue</th>
                                            <th>Transmission Type</th>
                                            <th>Nodes</th>
                                            <th>VOD Channels</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.keys(selectedFields.transmissions.value).length > 0 && (
                                            <tr className="text-nowrap">
                                                <td style={tableDataStyle}>{selectedFields.transmissions.value?.catalogue?.Catalogue?.Description}</td>
                                                <td style={tableDataStyle}>{selectedFields.transmissions.value?.catalogue?.TransmissionType?.Name}</td>
                                                <td style={tableDataStyle}>{selectedFields.transmissions.value?.catalogue?.ParentNodes?.map(node => node?.DisplayTitle).join(', ')}</td>
                                                <td style={tableDataStyle}>{selectedFields.transmissions.value?.catalogue?.Ott_Platforms?.map(node => node?.Description).join(', ')}</td>
                                            </tr>)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* Extension */}
                    <div style={style}>
                        <div>
                            <Checkbox style={{ borderColor: "black" }} name="extension" value={selectedFields.extension.isSelected} onChange={onCheckBoxSelection} />
                            <span style={subHeadingStyle}>Extension</span>
                        </div>
                        <div style={{ width: width, borderRadius: "4px" }}>
                            <AddRoundButton disabled={!selectedFields.extension.isSelected} onClick={() => setShowExtensionForm(true)} />
                            <div style={{ overflow: "auto", marginTop: "10px", scrollbarWidth: "none" }}>
                                <table className="table">
                                    <thead>
                                        <tr className="text-nowrap">
                                            <th>Working Title</th>
                                            <th>Episode No</th>
                                            <th>Total Episodes</th>
                                            <th>Content Platform</th>
                                            <th>Origin Countries</th>
                                            <th>Programme Language Id</th>
                                            {!isHideMetaDataFields && (
                                                <>
                                                    <th>Validity Start</th>
                                                    <th>Validity End</th>
                                                    <th>Premier Start Date</th>
                                                    <th>Premier Start Time</th>
                                                    <th>Premier End Date</th>
                                                    <th>Premier End Time</th>
                                                </>
                                            )}
                                            <th>Image URL 1</th>
                                            <th>Image URL 2</th>
                                            <th>Deal Reference</th>
                                            <th>Video Format</th>
                                            <th>Short Title</th>
                                            <th>Short Title Chinese</th>
                                            <th>Game ID</th>
                                            <th>Home Team</th>
                                            <th>Away Team</th>
                                            <th>New Title</th>
                                            <th>Audio Language 1</th>
                                            <th>Audio Language 2</th>
                                            <th>Subtitle Languages</th>
                                            <th>Subtitle Embedded</th>
                                            <th>Closed Caption Format</th>
                                            <th>Subtitle File Name</th>
                                            <th>Audio Mode</th>
                                            <th>Censorship</th>
                                            <th>Folder Name</th>
                                            <th>Audio Track</th>
                                            <th>ETV Display</th>
                                            <th>Start Over</th>
                                            <th>Cable VOD</th>
                                            <th>IPTV VOD</th>
                                            <th>Internet VOD</th>
                                            <th>OTT VOD</th>
                                            <th>SSAI VOD</th>
                                            <th>Download Video</th>
                                            <th>Thumbnail Required</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedFields?.extension?.isSelected && selectedFields?.extension?.value && (
                                            <tr className="text-nowrap">
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.workingTitle}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.episodeNumberForPress}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.totalEpisodes ?? "-"}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.contentPlatform}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.originCountries}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.programmeLanguageId}</td>
                                                {!isHideMetaDataFields && (
                                                    <>
                                                        <td style={tableDataStyle}>{selectedFields?.extension?.value?.validity?.validityStart ? moment(selectedFields?.extension?.value?.validity?.validityStart).format('DD-MM-YYYY') : ""}</td>
                                                        <td style={tableDataStyle}>{selectedFields?.extension?.value?.validity?.validityEnd ? moment(selectedFields?.extension?.value?.validity?.validityEnd).format('DD-MM-YYYY') : ""}</td>
                                                        <td style={tableDataStyle}>{selectedFields?.extension?.value?.validity?.premierStartDate ? moment(selectedFields?.extension?.value?.validity?.premierStartDate).format('DD-MM-YYYY') : ""}</td>
                                                        <td style={tableDataStyle}>{selectedFields?.extension?.value?.validity?.premierStartTime ? moment(selectedFields?.extension?.value?.validity?.premierStartTime).format('hh:mm') : ""}</td>
                                                        <td style={tableDataStyle}>{selectedFields?.extension?.value?.validity?.premierEndDate ? moment(selectedFields?.extension?.value?.validity?.premierEndDate).format('DD-MM-YYYY') : ""}</td>
                                                        <td style={tableDataStyle}>{selectedFields?.extension?.value?.validity?.premierEndTime ? moment(selectedFields?.extension?.value?.validity?.premierEndTime).format('hh:mm') : ""}</td>
                                                    </>
                                                )}
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.imageUrl1}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.imageUrl2}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.dealReference}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.videoFormat}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.shortDisplayTitle}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.shortDisplayTitleChinese}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.gameId}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.homeTeam}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.awayTeam}</td>
                                                <td style={tableDataStyle}> <input type="checkbox" checked={!!selectedFields?.extension?.value?.newTitle} readOnly /></td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.audioLanguage1}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.audioLanguage2}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.subtitleLanguages}</td>
                                                <td style={tableDataStyle}> <input type="checkbox" checked={!!selectedFields?.extension?.value?.subtitleEmbedded} readOnly /></td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.closedCaptionFileFormat}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.subtitleFileName}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.audioMode}</td>
                                                <td style={tableDataStyle}> <input type="checkbox" checked={!!selectedFields?.extension?.value?.censorship} readOnly /></td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.folderName}</td>
                                                <td style={tableDataStyle}>{selectedFields?.extension?.value?.audioTrack}</td>
                                                <td style={tableDataStyle}> <input type="checkbox" checked={!!selectedFields?.extension?.value?.etvDisplay} readOnly /></td>
                                                <td style={tableDataStyle}> <input type="checkbox" checked={!!selectedFields?.extension?.value?.isStartOver} readOnly /></td>
                                                <td style={tableDataStyle}> <input type="checkbox" checked={!!selectedFields?.extension?.value?.cableVOD} readOnly /></td>
                                                <td style={tableDataStyle}> <input type="checkbox" checked={!!selectedFields?.extension?.value?.iptvVOD} readOnly /></td>
                                                <td style={tableDataStyle}> <input type="checkbox" checked={!!selectedFields?.extension?.value?.internetVOD} readOnly /></td>
                                                <td style={tableDataStyle}> <input type="checkbox" checked={!!selectedFields?.extension?.value?.ottVOD} readOnly /></td>
                                                <td style={tableDataStyle}> <input type="checkbox" checked={!!selectedFields?.extension?.value?.ssaiVOD} readOnly /></td>
                                                <td style={tableDataStyle}> <input type="checkbox" checked={!!selectedFields?.extension?.value?.downloadVideo} readOnly /></td>
                                                <td style={tableDataStyle}> <input type="checkbox" checked={!!selectedFields?.extension?.value?.thumbnailRequiredFlag} readOnly /></td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showMediadealrights.show && <MediaDealRightEditForm entityName={entityName} isLinear={showMediadealrights.isLinear} onSave={onMediadealrightsSave} onClose={onMediadealrightsClose} />}
            {showTransmissionForm && <CreateTransmissionForm onSubmit={handleTransmissionSelection} onClose={() => setShowTransmissionForm(false)} />}
            {showExtensionForm && <BossDialog title={lang.extension_label} onClose={() => setShowExtensionForm(false)} width={"900px"}>
                <EditPageHeader title={""} onSubmit={onSaveExtensionData} onCancel={() => setShowExtensionForm(false)} showTitle={false} />
                <MediaExtensionEditForm item={selectedFields?.extension?.value || {}} onChangeExtensionData={onSaveExtension} isLong={isHideMetaDataFields} />
            </BossDialog>}
        </div >
    )
};

export default memo(MultipleContentEditPanel);